"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var normalizer_1 = __importDefault(require("../coupons/normalizer"));
var normalizer_2 = __importDefault(require("../referral/normalizer"));
var promoCodeNormalizer = function (response, country, status) {
    var data = {
        status: status,
        type: response.type,
    };
    if (response.type === 'referral' && response.referral) {
        data.referral = (0, normalizer_2.default)(response.referral, country, response.referral.referral_code);
    }
    if (response.type === 'coupon' && response.coupon) {
        var coupon = {
            data: response.coupon,
            status: 200,
            statusText: '',
            rawResponse: '',
            success: true,
        };
        data.coupon = (0, normalizer_1.default)(coupon, country).data;
    }
    return data;
};
exports.default = promoCodeNormalizer;
